import { cn } from "./lib/cn";

export interface SpinnerProps {
  size?: "sm" | "md" | "lg";
  /** Erişilebilirlik etiketi (ekran okuyucular için). */
  label?: string;
  className?: string;
}

const sizeClasses: Record<NonNullable<SpinnerProps["size"]>, string> = {
  sm: "size-4 border-2",
  md: "size-6 border-2",
  lg: "size-8 border-[3px]",
};

export function Spinner({ size = "md", label = "Yükleniyor", className }: SpinnerProps) {
  return (
    <span
      role="status"
      aria-label={label}
      className={cn(
        "inline-block animate-spin rounded-full border-slate-200 border-t-primary",
        sizeClasses[size],
        className,
      )}
    />
  );
}
